const { inject } = require("@vercel/analytics")

exports.onClientEntry = () => {
  inject()
}
